import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { InfoMailState, InfoMailTemplateDto } from '@models/resources/info-mail.model';

/**
 * Admin-Bereich „Info-Mail" (User-Feedback 2026-08).
 *
 * Vorlage (Betreff + Text) + beliebig viele Anhänge für den TX-Übergang
 * `open → info_sent`, plus Upload der zwei statischen Kunden-PDFs
 * (AGB + Musterkaufauftrag). Jede Mutation liefert den kompletten
 * Bereichs-Zustand zurück (eine Struktur für die ganze Seite).
 *
 * - `get()`                    → `GET  /info-mail`
 * - `saveTemplate(dto)`        → `PUT  /info-mail`
 * - `uploadAttachment(file)`   → `POST /info-mail/attachments`
 * - `deleteAttachment(id)`     → `DELETE /info-mail/attachments/{id}`
 * - `uploadAgb(file)`          → `POST /info-mail/agb`
 * - `uploadSampleOrder(file)`  → `POST /info-mail/sample-order`
 */
export interface AdminInfoMailFacade {
  get(): Observable<InfoMailState>;
  saveTemplate(dto: InfoMailTemplateDto): Observable<InfoMailState>;
  uploadAttachment(file: File): Observable<InfoMailState>;
  deleteAttachment(id: number): Observable<InfoMailState>;
  uploadAgb(file: File): Observable<InfoMailState>;
  uploadSampleOrder(file: File): Observable<InfoMailState>;
}

export const ADMIN_INFO_MAIL_FACADE = new InjectionToken<AdminInfoMailFacade>(
  'AdminInfoMailFacade',
);
